import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CreatableSelect from "react-select/creatable";
import {
  getExperience,
  registerStepOne,
  getRoles,
  getAllCities,
  getAllStates,
  getLocationChoice,
  completeProfile,
} from "../../redux/slices/authSlice";
import {
  Container,
  Row,
  Col,
  Card,
  Nav,
  Form,
  Button,
  InputGroup,
} from "react-bootstrap";
// import { showSuccess, showError } from "../../components/toasts/index";
import { showError } from "../../components/toasts/index";
// import { Formik, FieldArray } from "formik";
import { Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import "./registration-steps.scss";
import Step5CompareCityState from "./step5";
import SubscriptionCard from "./subscriptionCard";
import Select from "react-select";

import VerifyOtpModal from "./veryfy-otpmodal";

import { ReactComponent as CheckIcon } from "../../assets/images/check-icon.svg";
import { ReactComponent as ChevronRightIcon } from "../../assets/images/btn-right-aero.svg";
import { ReactComponent as ChevronLeftIcon } from "../../assets/images/btn-left-aero.svg";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";
import { ReactComponent as LogoDark } from "../../assets/images/logo-dark.svg";
import { ReactComponent as Facebook } from "../../assets/images/facebook.svg";
import { ReactComponent as Google } from "../../assets/images/google.svg";
import { ReactComponent as Instagram } from "../../assets/images/instagram.svg";
import { ReactComponent as AppIcon } from "../../assets/images/app-icon.svg";
import { ReactComponent as AndroindIcon } from "../../assets/images/android-icon.svg";
import { ReactComponent as AppleIcon } from "../../assets/images/apple_logo.svg";
import { ReactComponent as AppIconDark } from "../../assets/images/apple-icon-dark.svg";
import { ReactComponent as AndroindIconDark } from "../../assets/images/android-icon-dark.svg";
import { useTheme } from "../../context/ThemeContext";

import { ReactComponent as EyeOff } from "../../assets/images/eyeOff-icon.svg";
import { ReactComponent as Eye } from "../../assets/images/eye-icon.svg";

import { ReactComponent as FormLabelFacebook } from "../../assets/images/form-label-facebook.svg";
import { ReactComponent as FormLabelIntagram } from "../../assets/images/form-label-intagram.svg";
import { ReactComponent as FormLabelLinkedIn } from "../../assets/images/form-label-linkedin.svg";
import { Apple } from "lucide-react";
import UseGoogleLogin from "../../hooks/useGoogleLogin";
import UseInstagramLogin from "../../hooks/useInstaLogin";
import useFacebookLogin from "../../hooks/useFacebookLogin";
import { useAppleLogin } from "../../hooks/useAppleLogin";
import { activationTrack } from "../../redux/slices/trackActivitySlice";
import { getStoredUTMParams } from "../../utils/utmTracker";
import { popularWorkLocations } from "../../redux/slices/cityComparisonSlice";

// Yup validation schema for initial signup form
const signupSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .required("Name is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  phone: Yup.string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .optional(),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*]/,
      "Password must contain at least one special character",
    )
    .required("Password is required"),
  acceptedTerms: Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions")
    .required("You must accept the terms and conditions"),
});

const getValidationSchema = async (currentStep) => {
  const baseSchema = {};

  if (currentStep >= 1) {
    baseSchema.role = Yup.string().required("Please select your role");
  }

  if (currentStep >= 2) {
    baseSchema.experience = Yup.string().required(
      "Please select your experience",
    );
  }

  if (currentStep >= 3) {
    baseSchema.locationFactors = Yup.array()
      .of(Yup.string())
      .min(1, "Select at least one factor")
      .max(2, "You can only select up to two factors");
  }

  if (currentStep >= 4) {
    baseSchema.currentState = Yup.string().required(
      "Please select your current state",
    );
    baseSchema.currentCity = Yup.string().required(
      "Please select your current city",
    );
    baseSchema.destinationState = Yup.string().required(
      "Please select destination state",
    );
    baseSchema.destinationCity = Yup.string().required(
      "Please select destination city",
    );
  }

  if (currentStep >= 5) {
    baseSchema.comparisons = Yup.array()
      .of(
        Yup.object().shape({
          state: Yup.string().required("Please select a state"),
          city: Yup.string().required("Please select a city"),
        }),
      )
      .min(1, "Please add at least one comparison")
      .test(
        "is-valid-comparison",
        "Please complete all selected comparisons",
        (comparisons = []) => {
          if (!comparisons || comparisons.length === 0) return true;
          return comparisons.every(
            (comp) =>
              comp &&
              comp.state &&
              comp.city &&
              comp.state.trim() !== "" &&
              comp.city.trim() !== "",
          );
        },
      );
  }

  return Yup.object().shape(baseSchema);
};

const steps = [
  { number: 1, title: "What's your nursing role?" },
  { number: 2, title: "What city and state do you live in?" },
  { number: 3, title: "Where are you thinking about moving?" },
];
// const steps = [
//   { number: 1, title: "Current role" },
//   { number: 2, title: "Your years of experience" },
//   { number: 3, title: "Your location choice" },
//   { number: 4, title: "Your current city" },
//   { number: 5, title: "Compare by City and State" },
//   { number: 6, title: "Input your social profiles" },
//   { number: 7, title: "Upload Document" },
//   { number: 8, title: "Subscription" },
// ];

export default function RegistrationSteps(
  show,
  onHide,
  onSave,
  profiles = {},
  selectedSignup,
  selectedRegisterRole,
  selectedRegisterExperience,
  selectedRegisterChoice,
  selectedRegisterCities,
) {
  const { resolvedTheme } = useTheme();
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showRegistrationSteps, setShowRegistrationSteps] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [registerDestinations, setRegisterDestinations] = useState([]);
  const [fromRegister, setFromRegister] = useState(false);
  const [isSkipping, setIsSkipping] = useState(false);
  const { hash } = useLocation();
  const authUser = useSelector((state) => state.auth?.user);
  const userStore = useSelector((state) => state.profile);
  const hasTrackedRef = useRef(false);
  const hasProfileCompleted = userStore?.profileItem?.data?.activation_funnel?.progress?.some(
    (step) => step.step === "profile_completed" && step.completed,
  );
  const hasTrackedProfileRef = useRef(false);

  // Determine if user already has an active subscription
  const hasExistingSubscription = Boolean(
    authUser?.plan &&
      authUser?.plan_expiry_date &&
      new Date(authUser.plan_expiry_date) > new Date(), // optional: check not expired
  );

  const params = new URLSearchParams(window.location.search);
  const referralCode = params.get("ref");
  const postText = params.get("postText");
  const redirectPath = params.get("redirect");

  // Store postText and redirect path in localStorage if present
  useEffect(() => {
    if (postText) {
      localStorage.setItem("pendingPostText", postText);
    }
    if (redirectPath) {
      localStorage.setItem("pendingRedirect", redirectPath);
    }
  }, [postText, redirectPath]);

  // console.log(referralCode);

  const authStore = useSelector((state) => state.auth);
  // React Hook Form for initial signup
  const {
    register: registerSignup,
    handleSubmit: handleSubmitSignup,
    formState: { errors: signupErrors },
    // formState: { errors: signupErrors, touchedFields },
    watch,
  } = useForm({
    resolver: yupResolver(signupSchema),
    mode: "onChange", // Validate in real-time as user types
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      password: "",
      acceptedTerms: false,
    },
  });

  // Watch form values for use in onSubmitRole and nextStep functions
  const name = watch("name");
  const email = watch("email");

  const location = useLocation();
  const fromProfile = location.state ? location.state?.fromProfile : "";
  const fromProfileName = location.state?.name;
  const fromProfileEmail = location.state?.email;

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  const fromSocialLogin = location.state?.fromSocialLogin || false;
  const userFromSocial = location.state?.user;
  // useEffect(() => {
  //   if (fromProfile) {
  //     setShowRegistrationSteps(true);
  //   }
  // }, [fromProfile]);
  useEffect(() => {
    if (fromSocialLogin || fromProfile || fromRegister) {
      setShowRegistrationSteps(true);

      // Optional: clear state so it doesn't trigger again on refresh
      window.history.replaceState({}, document.title);
    }
  }, [fromSocialLogin, fromProfile, fromRegister]);

  // const handleSignUp = async (data) => {
  //   setErrorMessage("");

  //   const formData = {
  //     name: data.name,
  //     email: data.email,
  //     phone: data.phone,
  //     password: data.password,
  //     confirm_password: data.confirmPassword,
  //     terms: true,
  //     ...(referralCode?.trim() ? { referred_code: referralCode } : {}),
  //   };

  //   try {
  //     const resultAction = await dispatch(registerStepOne(formData));

  //     if (registerStepOne.fulfilled.match(resultAction)) {
  //       const createdUserId = resultAction.payload?.data?.user_id;

  //       setPendingUser(createdUserId);
  //       setShowOtpModal(true);
  //     } else {
  //       const msg =
  //         (resultAction.payload &&
  //           (resultAction.payload.message || resultAction.payload)) ||
  //         resultAction.error?.message ||
  //         "Signup failed";
  //       console.error("❌ Signup failed:", msg, resultAction);
  //       setErrorMessage(msg);
  //       showError(msg);
  //     }
  //   } catch (err) {
  //     console.error("❌ Unexpected error during signup:", err);
  //     setErrorMessage("An unexpected error occurred. Please try again.");
  //   }
  // };
  const handleSignUp = async (data) => {
    setErrorMessage("");

    // ✅ Get stored UTM params
    const utmParams = getStoredUTMParams();

    const formData = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      password: data.password,
      terms: true,

      device_type: "web",

      ...(referralCode?.trim() ? { referred_code: referralCode } : {}),

      // ✅ Attach UTM fields
      utm_source: utmParams?.utm_source || null,
      utm_medium: utmParams?.utm_medium || null,
      utm_campaign: utmParams?.utm_campaign || null,
      utm_content: utmParams?.utm_content || null,
      utm_captured_at: utmParams?.captured_at || null,
    };

    try {
      const resultAction = await dispatch(registerStepOne(formData));

      if (registerStepOne.fulfilled.match(resultAction)) {
        const createdUserId = resultAction.payload?.data?.user_id;

        setPendingUser(createdUserId);
        setShowOtpModal(true);
      } else {
        const msg =
          (resultAction.payload &&
            (resultAction.payload.message || resultAction.payload)) ||
          resultAction.error?.message ||
          "Signup failed";

        console.error("❌ Signup failed:", msg, resultAction);
        setErrorMessage(msg);
        showError(msg);
      }
    } catch (err) {
      console.error("❌ Unexpected error during signup:", err);
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };
  const onOtpVerified = async () => {
    // Get token and user data from Redux store (saved by verifyOtpLoginSignup)
    const token = registerStore?.token;

    // Token and user data should already be saved to localStorage by the Redux action
    // But we'll verify and log it here
    if (token) {
    } else {
      console.warn("⚠️ No token found in store after OTP verification");
    }

    setOtpVerified(true);
    setShowOtpModal(false);
    setIsAuthenticated(true);

    try {
      await Swal.fire({
        icon: "success",
        title: "OTP Verified",
        text: "Your phone/email has been verified. Lets complete your profile!",
        timer: 1800,
        showConfirmButton: false,
        customClass: {
          popup: "success-popup-modal",
        },
      });
    } catch (e) {
      console.error("Swal error:", e);
    }
  };

  const [registerRole, setRegisterRole] = useState(
    selectedRegisterRole || null,
  );
  const [registerExperience, setRegisterExperience] = useState(
    selectedRegisterExperience || null,
  );
  const [registerChoice, setRegisterChoice] = useState(
    selectedRegisterChoice || [],
  );
  const [registerCities, setRegisterCities] = useState({
    current: { state: null, city: null },
    destination: { state: null, city: null },
  });

  const [registerProfiles, setRegisterProfiles] = useState({
    facebook: { value: "" },
    instagram: { value: "" },
    linkedin: { value: "" },
  });
  const [file, setFile] = useState(null);
  const [secondFile, setSecondFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [secondFileUrl, setSecondFileUrl] = useState(null);
  const dispatch = useDispatch();
  const registerStore = useSelector((state) => state.auth);
  const [stateOptions, setStateOptions] = useState([]);
  const [currentCityOptions, setCurrentCityOptions] = useState([]);
  const [destinationCityOptions, setDestinationCityOptions] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const handleGoogleLogin = UseGoogleLogin();
  const {
    loginInsta: handleInstagramLogin,
    handleCallback,
  } = UseInstagramLogin();
  const { isLoading: isFacebookLoading } = useFacebookLogin();
  const { handleAppleLogin, isLoading: isAppleLoading } = useAppleLogin();
  // const {handleFacebookLogin,isLoading: isFacebookLoading,} = useFacebookLogin();

  const cityComparisonStore = useSelector((state) => state.cityComparison);

  useEffect(() => {
    dispatch(popularWorkLocations());
  }, [dispatch]);

  const popularCities =
    cityComparisonStore?.popularWorkLocationsItems?.data?.cities?.data || [];
  console.log(
    cityComparisonStore?.popularWorkLocationsItems,
    "FULL API RESPONSE",
  );
  const handleChoiceToggle = (choice, setFieldValue) => {
    setRegisterChoice((prevChoices) => {
      const newChoices = prevChoices.includes(choice.id)
        ? prevChoices.filter((id) => id !== choice.id)
        : [...prevChoices, choice.id];

      if (setFieldValue) {
        setFieldValue("locationFactors", newChoices);
      }
      return newChoices;
    });
  };

  const handleFileChange = (e, setFieldValue) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      if (setFieldValue) {
        setFieldValue("uploadedContract", selectedFile);
      }
      if (selectedFile instanceof File) {
        setFileUrl(URL.createObjectURL(selectedFile));
      }
    }
  };

  const handleSecondFileChange = (e, setFieldValue) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setSecondFile(selectedFile);
      if (setFieldValue) {
        setFieldValue("uploadedPayStubs", selectedFile);
      }
      if (selectedFile instanceof File) {
        setSecondFileUrl(URL.createObjectURL(selectedFile));
      }
    }
  };

  // Fetch data immediately after OTP verification
  useEffect(() => {
    if (isAuthenticated && otpVerified) {
      setIsLoadingData(true);

      Promise.all([
        dispatch(getRoles()),
        dispatch(getExperience()),
        dispatch(getLocationChoice()),
        dispatch(getAllStates()),
      ])
        .then(() => {
          setIsLoadingData(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setIsLoadingData(false);
        });
    }
  }, [isAuthenticated, otpVerified, dispatch]);

  useEffect(() => {
    setRegisterCities(
      selectedRegisterCities || {
        current: { state: null, city: null },
        destination: { state: null, city: null },
      },
    );
  }, [selectedRegisterCities]);
  // // Handle redirect after Instagram callback
  useEffect(() => {
    handleCallback();
  }, [handleCallback]);

  // Call API when current.state changes and update currentCityOptions
  useEffect(() => {
    if (registerCities?.current?.state?.code) {
      dispatch(
        getAllCities({
          search_state: registerCities.current.state.code,
          role: registerRole?.id || "",
        }),
      ).then((result) => {
        if (result.payload?.data?.cities || result.payload?.cities) {
          const cities = result.payload?.data?.cities || result.payload?.cities;
          const options = cities.map((cityObj) => ({
            value: cityObj.city,
            label: cityObj.city,
          }));
          setCurrentCityOptions(options);
        }
      });
    }
  }, [
    dispatch,
    registerCities,
    registerCities?.current?.state?.code,
    registerRole?.id,
  ]);

  // Call API when destination.state changes and update destinationCityOptions
  useEffect(() => {
    if (registerCities?.destination?.state?.code) {
      dispatch(
        getAllCities({
          search_state: registerCities.destination.state.code,
          role: registerRole?.id || "",
        }),
      ).then((result) => {
        if (result.payload?.data?.cities || result.payload?.cities) {
          const cities = result.payload?.data?.cities || result.payload?.cities;
          const options = cities.map((cityObj) => ({
            value: cityObj.city,
            label: cityObj.city,
          }));
          setDestinationCityOptions(options);
        }
      });
    }
  }, [dispatch, registerCities?.destination?.state?.code, registerRole?.id]);

  useEffect(() => {
    if (registerStore?.stateItems?.states) {
      const options = registerStore.stateItems.states.map((state) => ({
        value: state.id,
        label: state.state_full_name,
        code: state.state,
      }));
      setStateOptions(options);
    }
  }, [registerStore?.stateItems]);

  const onSubmitRole = async (isSkipActionOrValues = false) => {
    // Check if this is a skip action (boolean true) or normal form submission (object/false)
    const isSkipAction = isSkipActionOrValues === true;

    const formData = new FormData();
    const userId =
      pendingUser ||
      registerStore?.user?.user_id ||
      registerStore?.user?.id ||
      userFromSocial?.user_id ||
      userFromSocial?.id ||
      authStore?.newUser?.user_id ||
      authStore?.newUser?.id ||
      "";

    const finalName = fromProfile
      ? fromProfileName
      : fromSocialLogin
      ? userFromSocial?.name
      : authStore
      ? authStore?.newUser?.name
      : name;

    const finalEmail = fromProfile
      ? fromProfileEmail
      : fromSocialLogin
      ? userFromSocial?.email
      : registerStore?.user?.email ||
        registerStore?.newUser?.email ||
        authStore?.newUser?.email ||
        email ||
        "";

    formData.append("user_id", userId.toString());
    formData.append("name", finalName || "");
    formData.append("email", finalEmail || "");
    formData.append("reg_type", "normal");

    // Use actual data if provided, otherwise use defaults
    if (registerRole?.id) {
      formData.append("current_role_id", registerRole.id.toString());
    } else {
      const defaultRole = registerStore?.roleItems?.describe_roles?.find(
        (r) =>
          r.name.toLowerCase().includes("registered") ||
          r.name.toLowerCase().includes("rn"),
      );
      formData.append("current_role_id", defaultRole?.id || "1");
    }

    formData.append("living_state", registerCities?.current?.state?.code || "");

    formData.append("city", registerCities?.current?.city?.value || "");

    formData.append(
      "work_state",
      registerCities?.destination?.state?.code || "",
    );

    formData.append(
      "work_city",
      registerCities?.destination?.city?.value || "",
    );

    const finalIsSubscribed = hasExistingSubscription || isTrialOrSubscribed;

    formData.append("is_subscribed", finalIsSubscribed ? "true" : "false");

    // Calculate profile completion percentage based on what's filled
    // let completionPercentage = 0;

    // // If user is skipping, set to 50%, otherwise set to 100% when completing
    // if (isSkipAction) {
    //   completionPercentage = 50;
    // } else {
    //   completionPercentage = 100;
    // }
    let completionPercentage = 0;

    if (isSkipAction) {
      completionPercentage = 40;
    } else {
      const isStep1Filled = !!registerRole?.id;

      const isStep2Filled =
        !!registerCities?.current?.state?.code &&
        !!registerCities?.current?.city?.value;

      const isStep3Filled =
        !!registerCities?.destination?.state?.code &&
        !!registerCities?.destination?.city?.value;

      if (isStep1Filled && isStep2Filled && isStep3Filled) {
        completionPercentage = 100;
      } else if (isStep1Filled && isStep2Filled) {
        completionPercentage = 70;
      } else if (isStep1Filled) {
        completionPercentage = 40;
      } else {
        completionPercentage = 0;
      }
    }

    formData.append(
      "profile_completed_percentage",
      completionPercentage.toString(),
    );
    formData.append(
      "is_complete_signup",
      completionPercentage >= 80 ? "1" : "0",
    );
    formData.append("device_type", "web");
    formData.append("device_token", "");

    try {
      const result = await dispatch(completeProfile(formData));
      if (completeProfile.fulfilled.match(result)) {
        const message =
          completionPercentage >= 70
            ? "Your profile has been completed successfully!"
            : "Your profile has been created with default settings.";

        // ✅ Fire activation event ONLY if profile fully completed
        if (
          completionPercentage >= 70 &&
          !hasProfileCompleted &&
          !hasTrackedProfileRef.current
        ) {
          hasTrackedProfileRef.current = true;

          await dispatch(
            activationTrack({
              event_name: "profile_completed",
              platform: "web",
            }),
          );
        }

        await Swal.fire({
          icon: "success",
          title: "Profile Completed!",
          text: message,
          timer: 2000,
          showConfirmButton: false,
          customClass: { popup: "success-popup-modal" },
        });

        // ✅ Check for pending redirect (e.g., /community)
        const pendingRedirect = localStorage.getItem("pendingRedirect");

        if (pendingRedirect) {
          navigate(pendingRedirect);
          localStorage.removeItem("pendingRedirect"); // Clean up
        } else {
          navigate("/tour?fromSignup=true");
        }
      } else {
        showError(result.payload || "Failed to complete profile");
      }
    } catch (error) {
      showError("An error occurred while submitting your profile");
    }
  };
  // const onSubmitRole = async (isSkipActionOrValues = false) => {
  //   // Check if this is a skip action (boolean true) or normal form submission (object/false)
  //   const isSkipAction = isSkipActionOrValues === true;

  //   const formData = new FormData();

  //   const userId =
  //     pendingUser ||
  //     registerStore?.user?.user_id ||
  //     registerStore?.user?.id ||
  //     userFromSocial?.user_id ||
  //     authStore?.newUser?.user_id ||
  //     "";

  //   const finalName = fromProfile
  //     ? fromProfileName
  //     : fromSocialLogin
  //     ? userFromSocial?.name
  //     : authStore
  //     ? authStore?.newUser?.name
  //     : name;

  //   const finalEmail = fromProfile
  //     ? fromProfileEmail
  //     : fromSocialLogin
  //     ? userFromSocial?.email
  //     : registerStore?.user?.email ||
  //       registerStore?.newUser?.email ||
  //       authStore?.newUser?.email ||
  //       email ||
  //       "";

  //   formData.append("user_id", userId.toString());
  //   formData.append("name", finalName || "");
  //   formData.append("email", finalEmail || "");
  //   formData.append("reg_type", "normal");

  //   // Use actual data if provided, otherwise use defaults
  //   if (registerRole?.id) {
  //     formData.append("current_role_id", registerRole.id.toString());
  //   } else {
  //     const defaultRole = registerStore?.roleItems?.describe_roles?.find(
  //       (r) =>
  //         r.name.toLowerCase().includes("registered") ||
  //         r.name.toLowerCase().includes("rn"),
  //     );
  //     formData.append("current_role_id", defaultRole?.id || "1");
  //   }

  //   // if (registerExperience?.id) {
  //   //   formData.append(
  //   //     "nursing_experiences_id",
  //   //     registerExperience.id.toString(),
  //   //   );
  //   // } else {
  //   //   formData.append("nursing_experiences_id", "1");
  //   // }

  //   // Current location
  //   // if (registerCities?.current?.state?.code) {
  //   //   formData.append("living_state", registerCities.current.state.code);
  //   // } else {
  //   //   formData.append("living_state", "CA");
  //   // }

  //   // if (registerCities?.current?.city?.value) {
  //   //   formData.append("city", registerCities.current.city.value);
  //   // } else {
  //   //   formData.append("city", "Sacramento");
  //   // }
  //   formData.append("living_state", registerCities?.current?.state?.code || "");

  //   formData.append("city", registerCities?.current?.city?.value || "");

  //   // Destination location
  //   // if (registerCities?.destination?.state?.code) {
  //   //   formData.append("work_state", registerCities.destination.state.code);
  //   // } else {
  //   //   formData.append("work_state", "CA");
  //   // }

  //   // if (registerCities?.destination?.city?.value) {
  //   //   formData.append("work_city", registerCities.destination.city.value);
  //   // } else {
  //   //   formData.append("work_city", "Sacramento");
  //   // }
  //   formData.append(
  //     "work_state",
  //     registerCities?.destination?.state?.code || "",
  //   );

  //   formData.append(
  //     "work_city",
  //     registerCities?.destination?.city?.value || "",
  //   );

  //   // // Interested states
  //   // if (registerDestinations && registerDestinations.length > 0) {
  //   //   const interestedStates = JSON.stringify(
  //   //     registerDestinations.map((d) => ({
  //   //       state: d.state?.label || "",
  //   //       city: d.city?.value || "",
  //   //     })),
  //   //   );
  //   //   formData.append("interested_state", interestedStates);
  //   // } else {
  //   //   formData.append(
  //   //     "interested_state",
  //   //     JSON.stringify([{ state: "TX", city: "Houston" }]),
  //   //   );
  //   // }

  //   // // Social profiles
  //   // formData.append("fb_profile_url", registerProfiles.facebook.value || "");
  //   // formData.append(
  //   //   "insta_profile_url",
  //   //   registerProfiles.instagram.value || "",
  //   // );
  //   // formData.append(
  //   //   "linkedin_profile_url",
  //   //   registerProfiles.linkedin.value || "",
  //   // );

  //   // // Location choices
  //   // if (registerChoice && registerChoice.length > 0) {
  //   //   registerChoice.forEach((choiceId, index) => {
  //   //     formData.append(`locations_for[${index}]`, choiceId.toString());
  //   //   });
  //   // } else {
  //   //   formData.append("locations_for[0]", "1");
  //   // }

  //   // // Documents
  //   // if (file) formData.append("doc_one", file);
  //   // if (secondFile) formData.append("doc_two", secondFile);

  //   const finalIsSubscribed = hasExistingSubscription || isTrialOrSubscribed;

  //   formData.append("is_subscribed", finalIsSubscribed ? "true" : "false");

  //   // Calculate profile completion percentage based on what's filled
  //   let completionPercentage = 0;

  //   // If user is skipping, set to 50%, otherwise set to 100% when completing
  //   if (isSkipAction) {
  //     completionPercentage = 50;
  //   } else {
  //     completionPercentage = 100;
  //   }

  //   formData.append(
  //     "profile_completed_percentage",
  //     completionPercentage.toString(),
  //   );
  //   formData.append(
  //     "is_complete_signup",
  //     completionPercentage >= 80 ? "1" : "0",
  //   );
  //   formData.append("device_type", "web");
  //   formData.append("device_token", "");

  //   // try {
  //   //   const result = await dispatch(completeProfile(formData));
  //   //   if (completeProfile.fulfilled.match(result)) {
  //   //     const message =
  //   //       completionPercentage >= 70
  //   //         ? "Your profile has been completed successfully!"
  //   //         : "Your profile has been created with default settings.";

  //   //     await Swal.fire({
  //   //       icon: "success",
  //   //       title: "Profile Completed!",
  //   //       text: message,
  //   //       timer: 2000,
  //   //       showConfirmButton: false,
  //   //       customClass: { popup: "success-popup-modal" },
  //   //     });
  //   //     navigate("/tour");
  //   //   } else {
  //   //     showError(result.payload || "Failed to complete profile");
  //   //   }
  //   // } catch (error) {
  //   //   showError("An error occurred while submitting your profile");
  //   // }
  //   try {
  //     const result = await dispatch(completeProfile(formData));
  //     if (completeProfile.fulfilled.match(result)) {
  //       const message =
  //         completionPercentage >= 70
  //           ? "Your profile has been completed successfully!"
  //           : "Your profile has been created with default settings.";

  //       // ✅ Fire activation event ONLY if profile fully completed
  //       if (
  //         completionPercentage >= 70 &&
  //         !hasProfileCompleted &&
  //         !hasTrackedProfileRef.current
  //       ) {
  //         hasTrackedProfileRef.current = true;

  //         await dispatch(
  //           activationTrack({
  //             event_name: "profile_completed",
  //             platform: "web",
  //           }),
  //         );
  //       }

  //       await Swal.fire({
  //         icon: "success",
  //         title: "Profile Completed!",
  //         text: message,
  //         timer: 2000,
  //         showConfirmButton: false,
  //         customClass: { popup: "success-popup-modal" },
  //       });

  //       // navigate("/dashboard");
  //       navigate("/dashboard?fromSignup=true");
  //     } else {
  //       showError(result.payload || "Failed to complete profile");
  //     }
  //   } catch (error) {
  //     showError("An error occurred while submitting your profile");
  //   }
  // };

  const { isLoading } = useSelector((state) => state && state.auth);
  // const { isLoading, isError } = useSelector((state) => state && state.auth);

  // activePlan / plansData removed — SubscriptionCard fetches plans from
  // redux on its own and ignores any external `plan` prop.
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [isTrialOrSubscribed, setIsTrialOrSubscribed] = useState(false);
  const totalSteps = steps.length;

  const initialValues = {
    role: registerRole?.id?.toString() || "",
    experience: registerExperience?.id?.toString() || "",
    preferredLocation: "",
    locationFactors: registerChoice || [],
    currentState: registerCities?.current?.state?.value || "",
    currentCity: registerCities?.current?.city?.value || "",
    destinationState: registerCities?.destination?.state?.value || "",
    destinationCity: registerCities?.destination?.city?.value || "",
    comparisons:
      registerDestinations && registerDestinations.length > 0
        ? registerDestinations.map((dest) => ({
            state: dest.state?.value || "",
            city: dest.city?.value || "",
          }))
        : [{ state: "", city: "" }],
    billingCycle: "monthly",
    socialProfiles: {
      facebook: registerProfiles?.facebook?.value || "",
      instagram: registerProfiles?.instagram?.value || "",
      linkedin: registerProfiles?.linkedin?.value || "",
    },
    uploadedContract: file || null,
    uploadedPayStubs: secondFile || null,
    subscriptionPlan: "",
  };

  const nextStep = () => {
    setStep((prevStep) => Math.min(prevStep + 1, totalSteps));
  };

  const prevStep = () => {
    setStep((prevStep) => Math.max(prevStep - 1, 1));
  };
  const handleReset = (currentStep) => {
    switch (currentStep) {
      case 1:
        setRegisterRole(null);
        setRegisterExperience(null);
        setRegisterChoice([]);
        setRegisterCities({
          current: { state: null, city: null },
          destination: { state: null, city: null },
        });
        setRegisterDestinations([]);
        setRegisterProfiles({
          facebook: { value: "" },
          instagram: { value: "" },
          linkedin: { value: "" },
        });
        setFile(null);
        setSecondFile(null);
        break;
      case 2:
        setRegisterExperience(null);
        setRegisterChoice([]);
        setRegisterCities({
          current: { state: null, city: null },
          destination: { state: null, city: null },
        });
        setRegisterDestinations([]);
        setRegisterProfiles({
          facebook: { value: "" },
          instagram: { value: "" },
          linkedin: { value: "" },
        });
        setFile(null);
        setSecondFile(null);
        break;
      case 3:
        setRegisterChoice([]);
        setRegisterCities({
          current: { state: null, city: null },
          destination: { state: null, city: null },
        });
        setRegisterDestinations([]);
        setRegisterProfiles({
          facebook: { value: "" },
          instagram: { value: "" },
          linkedin: { value: "" },
        });
        setFile(null);
        setSecondFile(null);
        break;
      case 4:
        setRegisterCities({
          current: { state: null, city: null },
          destination: { state: null, city: null },
        });
        setRegisterDestinations([]);
        setRegisterProfiles({
          facebook: { value: "" },
          instagram: { value: "" },
          linkedin: { value: "" },
        });
        setFile(null);
        setSecondFile(null);
        break;
      case 5:
        setRegisterDestinations([]);
        setRegisterProfiles({
          facebook: { value: "" },
          instagram: { value: "" },
          linkedin: { value: "" },
        });
        setFile(null);
        setSecondFile(null);
        break;
      case 6:
        setRegisterProfiles({
          facebook: { value: "" },
          instagram: { value: "" },
          linkedin: { value: "" },
        });
        setFile(null);
        setSecondFile(null);
        break;
      case 7:
        setFile(null);
        setSecondFile(null);
        break;
      default:
        break;
    }
  };

  const handleSkip = async () => {
    setIsSkipping(true);

    try {
      handleReset(step);
      await onSubmitRole(true); // Pass true to indicate this is a skip action
    } catch (error) {
      console.error("Skip failed:", error);
      showError("Failed to skip and save profile. Please try again.");
    } finally {
      setIsSkipping(false);
    }
  };
  const handlePopularDestinationSelect = (item, setFieldValue) => {
    const selectedState = stateOptions.find((s) => s.code === item.state);

    const selectedCity = {
      label: item.city,
      value: item.city,
    };

    // Update state
    setRegisterCities((prev) => ({
      ...prev,
      destination: {
        state: selectedState,
        city: selectedCity,
      },
    }));

    // Update Formik
    setFieldValue("destinationState", selectedState?.value || "");
    setFieldValue("destinationCity", selectedCity?.value || "");
  };
  const isDataLoaded =
    registerStore?.roleItems?.describe_roles &&
    registerStore?.experienceItems?.nursing_experiences &&
    registerStore?.locationChoiceItems?.location_choices &&
    registerStore?.stateItems?.states;

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [hash]);

  useEffect(() => {
    if (showRegistrationSteps || authStore?.newUser === true) {
      setIsLoadingData(true);

      Promise.all([
        dispatch(getRoles()),
        dispatch(getExperience()),
        dispatch(getLocationChoice()),
        dispatch(getAllStates()),
      ])
        .then(() => {
          setIsLoadingData(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setIsLoadingData(false);
        });
    }
  }, [showRegistrationSteps, authStore?.newUser, dispatch]);

  const onGoogleLoginClick = async () => {
    try {
      await handleGoogleLogin(); // triggers the login popup
    } catch (error) {
      console.error("Google login error:", error);
      alert(error.message || "Google login failed. Please try again.");
    }
  };

  // Handle navigation after social login completes
  useEffect(() => {
    const actionFlag = authStore?.actionFlag;

    console.log("🔍 Social login effect triggered:", {
      actionFlag,
      isSuccess: authStore?.isSuccess,
      token: authStore?.token,
      user: authStore?.user,
      newUser: authStore?.newUser,
    });

    // Only handle social login action flags
    if (actionFlag === "SOCIAL_LOGIN_SUCCESS") {
      // Existing user with completed profile - go to dashboard

      navigate("/dashboard", { replace: true });
    } else if (actionFlag === "SOCIAL_SIGNUP_SUCCESS") {
      // New user or incomplete profile - stay on registration and show steps

      setShowRegistrationSteps(true);
      setFromRegister(true);
    }
  }, [authStore?.actionFlag, navigate]);

  const onInstaLoginClick = async () => {
    try {
      await handleInstagramLogin();
    } catch (error) {
      console.error("Instagram login error:", error);
      alert(error.message || "Instagram login failed. Please try again.");
    }
  };

  // Handle Apple login button click
  const onAppleLoginClick = async () => {
    try {
      await handleAppleLogin();
    } catch (error) {
      console.error("Apple login error:", error);
      alert(error.message || "Apple login failed. Please try again.");
    }
  };

  return (
    <>
      {!(isAuthenticated && otpVerified) ? (
        !showRegistrationSteps ? (
          <section className="login-content with-register" id="register">
            <Container>
              <div className="login-content-row">
                <Row>
                  <Col lg={6} className="social-login-content">
                    <Card>
                      <Card.Body>
                        <div className="logo-imgs">
                          {resolvedTheme === "dark" ? <LogoDark /> : <Logo />}
                        </div>
                        <div className="content text-center">
                          <p>Create your free account</p>
                        </div>
                        <div className="social-login">
                          <Button className="social facebook">
                            <div className="imgs">
                              <Facebook />
                            </div>
                            <div className="text">Sign Up with Facebook</div>
                          </Button>
                          <Button
                            className="social google"
                            onClick={onGoogleLoginClick}
                            disabled={isLoading || isFacebookLoading}
                          >
                            <div className="imgs">
                              <Google />
                            </div>
                            <div className="text">Sign Up with google+</div>
                          </Button>
                         {/* <Button
                            className="social instagram"
                            onClick={() => onInstaLoginClick()}
                            disabled={isLoading || isFacebookLoading}
                          >
                            <div className="imgs">
                              <Instagram />
                            </div>
                            <div className="text">Sign Up with instagram</div>
                          </Button> */}
                          <Button
                            className="social apple"
                            onClick={onAppleLoginClick}
                            disabled={isLoading || isAppleLoading}
                          >
                            <div className="imgs">
                              <AppleIcon />
                            </div>
                            <div className="text">
                              {isAppleLoading
                                ? "Connecting..."
                                : "Sign Up with Apple"}
                            </div>
                          </Button>
                        </div>
                        <div className="content text-center pt-4 pb-2">
                          <p>Download our app for the best experience.</p>
                        </div>
                        <div className="app-icon text-center">
                          <a
                            href="https://apps.apple.com/us/app/map-my-pay/id6747190135"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Download on App Store"
                          >
                            {resolvedTheme === "dark" ? (
                              <AppIconDark />
                            ) : (
                              <AppIcon />
                            )}
                          </a>
                          <a
                            href="https://play.google.com/store/apps/details?id=com.mapmypay"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Get it on Google Play"
                          >
                            {resolvedTheme === "dark" ? (
                              <AndroindIconDark />
                            ) : (
                              <AndroindIcon />
                            )}
                          </a>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col lg={6} className="login">
                    <Card>
                      <Card.Body>
                        <div className="content text-center">
                          <h5>Welcome</h5>
                          <p>Create your free account</p>
                        </div>
                        <Form onSubmit={handleSubmitSignup(handleSignUp)}>
                          <Form.Group className="form-group">
                            <Form.Label className="col-label">Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your name"
                              {...registerSignup("name")}
                              className="col-input"
                              isInvalid={!!signupErrors.name}
                            />
                            {signupErrors.name && (
                              <Form.Control.Feedback type="invalid">
                                {signupErrors.name?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          <Form.Group className="form-group" controlId="email">
                            <Form.Label className="col-label">
                              Email address
                            </Form.Label>
                            <Form.Control
                              type="email"
                              {...registerSignup("email")}
                              placeholder="Enter email address"
                              className="col-input"
                              isInvalid={!!signupErrors.email}
                            />

                            {signupErrors.email && (
                              <Form.Control.Feedback type="invalid">
                                {signupErrors.email?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          <p
                            className="mb-2"
                            style={{
                              fontSize: "0.775rem",
                              lineHeight: "18px",
                              color: "var(--mmp-text-secondary)",
                            }}
                          >
                            *Password must be min 8 characters, including
                            numbers and special characters
                          </p>
                          <Form.Group
                            className="form-group"
                            controlId="password"
                          >
                            <Form.Label className="col-label">
                              Password
                            </Form.Label>
                            <InputGroup hasValidation>
                              <Form.Control
                                type={showPassword ? "text" : "password"}
                                {...registerSignup("password")}
                                placeholder="************"
                                className="col-input"
                                isInvalid={!!signupErrors.password}
                              />
                              <Button
                                variant="outline-secondary"
                                type="button"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label="Toggle password visibility"
                              >
                                {showPassword ? (
                                  <Eye size={20} />
                                ) : (
                                  <EyeOff size={20} />
                                )}
                              </Button>
                            </InputGroup>
                            {signupErrors.password && (
                              <Form.Control.Feedback type="invalid">
                                {signupErrors.password?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          <Form.Group className="form-group">
                            <Form.Label className="col-label">
                              Phone{" "}
                              <span
                                style={{
                                  fontWeight: 400,
                                  color: "var(--mmp-text-secondary)",
                                  fontSize: "0.75rem",
                                }}
                              >
                                (Optional)
                              </span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              {...registerSignup("phone")}
                              className="col-input"
                              placeholder="Enter phone Number"
                              isInvalid={!!signupErrors.phone}
                            />
                            {signupErrors.phone && (
                              <Form.Control.Feedback type="invalid">
                                {signupErrors.phone?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          <Form.Group className="form-group">
                            <div className="checkbox-content">
                              <input
                                type="checkbox"
                                id="rememberMe"
                                {...registerSignup("acceptedTerms")}
                              />
                              <label
                                htmlFor="rememberMe"
                                className="cursor-pointer"
                              >
                                Accept
                                <a
                                  href="https://mapmypay.com/terms-conditions/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {" "}
                                  terms & conditions{" "}
                                </a>{" "}
                                ,
                                <a
                                  href="https://mapmypay.com/privacy-policy/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {" "}
                                  privacy policy{" "}
                                </a>{" "}
                                and
                                <a
                                  href="https://mapmypay.com/eula/"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {" "}
                                  EULA
                                </a>{" "}
                                of Map my Pay
                              </label>
                            </div>
                            {signupErrors.acceptedTerms && (
                              <Form.Control.Feedback
                                type="invalid"
                                style={{ display: "block" }}
                              >
                                {signupErrors.acceptedTerms?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          {(registerStore?.errorMessage || errorMessage) && (
                            <div className="error-alert">
                              <p className="error-message mt-0">
                                {errorMessage || registerStore?.errorMessage}
                              </p>
                            </div>
                          )}

                          <div className="buttons">
                            <Button
                              type="submit"
                              variant="primary"
                              className="w-100"
                              disabled={isLoading}
                            >
                              {isLoading ? "Signing Up..." : "Sign Up"}
                            </Button>
                          </div>

                          <div className="signup-content">
                            Already have an account?{" "}
                            <Nav.Link
                              as={NavLink}
                              to={
                                redirectPath
                                  ? `/login?redirect=${encodeURIComponent(
                                      redirectPath,
                                    )}`
                                  : "/login"
                              }
                            >
                              Log in
                            </Nav.Link>
                          </div>
                        </Form>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Container>
            {showOtpModal && (
              <VerifyOtpModal
                show={showOtpModal}
                handleClose={() => setShowOtpModal(false)}
                onOtpVerified={onOtpVerified}
                createdUserId={pendingUser}
              />
            )}
          </section>
        ) : (
          <section className="login-content with-register">
            <div className="breadcrumbs pb-0">
              <Container>
                <nav aria-label="Breadcrumb">
                  <ul className="breadcrumb-list">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <span>Home</span>
                      </a>
                    </li>
                    <li className="breadcrumb-sep" aria-hidden="true">
                      /
                    </li>
                    <li className="breadcrumb-item current" aria-current="page">
                      <span>Registration Steps</span>
                    </li>
                  </ul>
                </nav>
              </Container>
            </div>

            <div className="registration-content">
              <Container>
                {isLoadingData || !isDataLoaded ? (
                  <div className="text-center py-5">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading form data...</p>
                    {/* Debug info */}
                    {/* (
                    <div className="mt-3 text-muted small">
                      <p>
                        Roles:{" "}
                        {registerStore?.roleItems?.describe_roles ? "✓" : "✗"}
                      </p>
                      <p>
                        Experience:{" "}
                        {registerStore?.experienceItems?.nursing_experiences
                          ? "✓"
                          : "✗"}
                      </p>
                      <p>
                        Location Choices:{" "}
                        {registerStore?.locationChoiceItems?.location_choices
                          ? "✓"
                          : "✗"}
                      </p>
                      <p>
                        States: {registerStore?.stateItems?.states ? "✓" : "✗"}
                      </p>
                    </div>
                    ) */}
                  </div>
                ) : (
                  <Formik
                    initialValues={initialValues}
                    onSubmit={onSubmitRole}
                    validate={(values) => {
                      const schema = getValidationSchema(step);
                      try {
                        schema.validateSync(values, { abortEarly: false });
                        return {};
                      } catch (error) {
                        const errors = {};
                        if (error && Array.isArray(error.inner)) {
                          error.inner.forEach((err) => {
                            if (err.path && !errors[err.path]) {
                              errors[err.path] = err.message;
                            }
                          });
                        }
                        return errors;
                      }
                    }}
                    validateOnChange={true}
                    validateOnBlur={true}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="registration-form"
                      >
                        <div className="row">
                          <div className="progress-card">
                            <div className="content-wrap">
                              <ul className="steps-list">
                                {steps.map((item) => (
                                  <li
                                    key={item.number}
                                    className={`step-item ${
                                      step === item.number ? "active" : ""
                                    } ${step > item.number ? "completed" : ""}`}
                                  >
                                    <div className="step-marker">
                                      {step > item.number ? (
                                        <CheckIcon className="check-icon" />
                                      ) : (
                                        <span className="step-number">
                                          {item.number}
                                        </span>
                                      )}
                                    </div>
                                    <div className="step-details">
                                      <div className="step-title">
                                        Step{" "}
                                        {step > item.number ? item.number : ""}
                                      </div>
                                      <div className="step-description">
                                        {item.title}
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>

                          <div className="form-content-card">
                            <div className="content-wrap">
                              {step === 1 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>
                                        What best describes your current role?
                                      </h5>

                                      <p className="step-subtitle">
                                        Select your nursing role to view salary
                                        data and career insights tailored to
                                        your profession. This helps ensure
                                        accurate comparisons and guidance.
                                      </p>
                                    </div>
                                    {/* <div className="skip-btn d-none d-xl-block"> */}
                                    <div className="skip-btn d-none d-xl-block">
                                      <button
                                        type="button"
                                        onClick={handleSkip}
                                        disabled={isSkipping || isLoading}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        {isSkipping ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          </>
                                        ) : (
                                          "Skip"
                                        )}
                                      </button>
                                    </div>
                                  </div>

                                  <div className="radio-options">
                                    <div className="row">
                                      {registerStore?.roleItems?.describe_roles
                                        ?.length > 0 ? (
                                        registerStore.roleItems.describe_roles.map(
                                          (role) => (
                                            <div
                                              key={role.id}
                                              className={`radio-option col-lg-6 ${
                                                registerRole?.id === role.id
                                                  ? "selected"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                setRegisterRole(role);
                                                setFieldValue(
                                                  "role",
                                                  role.id.toString(),
                                                );
                                              }}
                                            >
                                              <div className="contentwrap">
                                                <input
                                                  type="radio"
                                                  name="role"
                                                  id={`role-${role.id}`}
                                                  checked={
                                                    registerRole?.id === role.id
                                                  }
                                                  onChange={() => {}}
                                                />
                                                <label
                                                  htmlFor={`role-${role.id}`}
                                                  className="radio-label"
                                                >
                                                  {role.name}
                                                </label>
                                              </div>
                                            </div>
                                          ),
                                        )
                                      ) : (
                                        <div className="col-12 text-center py-4">
                                          <p>Loading roles...</p>
                                        </div>
                                      )}
                                    </div>
                                    {errors.role && touched.role && (
                                      <div className="error-message text-danger mt-2">
                                        {errors.role}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* {step === 2 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>
                                        How many years of nursing experience do
                                        you have?
                                      </h5>
                                      <p className="step-subtitle">
                                        Enter your years of experience to get
                                        salary insights that match your career
                                        stage and expertise level.
                                      </p>
                                    </div>
                                    <div className="skip-btn d-none d-xl-block ">
                                      <button
                                        type="button"
                                        onClick={handleSkip}
                                        disabled={isSkipping || isLoading}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        {isSkipping ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          </>
                                        ) : (
                                          "Skip"
                                        )}
                                      </button>
                                    </div>
                                  </div>

                                  <div className="radio-options">
                                    <div className="row">
                                      {registerStore?.experienceItems
                                        ?.nursing_experiences?.length > 0 ? (
                                        registerStore.experienceItems.nursing_experiences.map(
                                          (exp) => (
                                            <div
                                              key={exp.id}
                                              className={`radio-option col-lg-6 ${
                                                registerExperience?.id ===
                                                exp.id
                                                  ? "selected"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                setRegisterExperience(exp);
                                                setFieldValue(
                                                  "experience",
                                                  exp.id.toString(),
                                                );
                                              }}
                                            >
                                              <div className="contentwrap">
                                                <input
                                                  type="radio"
                                                  name="experience"
                                                  id={`exp-${exp.id}`}
                                                  checked={
                                                    registerExperience?.id ===
                                                    exp.id
                                                  }
                                                  onChange={() => {}}
                                                />
                                                <label
                                                  htmlFor={`exp-${exp.id}`}
                                                  className="radio-label"
                                                >
                                                  {exp.name}
                                                </label>
                                              </div>
                                            </div>
                                          ),
                                        )
                                      ) : (
                                        <div className="col-12 text-center py-4">
                                          <p>Loading experience levels...</p>
                                        </div>
                                      )}
                                    </div>
                                    {touched.experience &&
                                      errors.experience && (
                                        <div className="error-message text-danger mt-2">
                                          {errors.experience}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              )} */}

                              {/* {step === 3 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>
                                        Which factors are most important in your
                                        location choice?
                                      </h5>
                                      <p className="step-subtitle">
                                        Choose up to two factors that matter
                                        most such as salary, cost of living, job
                                        opportunities, or lifestyle
                                      </p>
                                    </div>
                                    <div className="skip-btn d-none d-xl-block ">
                                      <button
                                        type="button"
                                        onClick={handleSkip}
                                        disabled={isSkipping || isLoading}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        {isSkipping ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          </>
                                        ) : (
                                          "Skip"
                                        )}
                                      </button>
                                    </div>
                                  </div>

                                  <div className="checkbox-options">
                                    <div className="row">
                                      {registerStore?.locationChoiceItems
                                        ?.location_choices?.length > 0 ? (
                                        registerStore.locationChoiceItems.location_choices.map(
                                          (choice) => (
                                            <div
                                              key={choice.id}
                                              className={`checkbox-option col-lg-6 ${
                                                registerChoice.includes(
                                                  choice.id,
                                                )
                                                  ? "selected"
                                                  : ""
                                              }`}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleChoiceToggle(
                                                  choice,
                                                  setFieldValue,
                                                );
                                              }}
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="contentwrap">
                                                <input
                                                  type="checkbox"
                                                  name={`choice-${choice.id}`}
                                                  id={`choice-${choice.id}`}
                                                  checked={registerChoice.includes(
                                                    choice.id,
                                                  )}
                                                  onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleChoiceToggle(
                                                      choice,
                                                      setFieldValue,
                                                    );
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                />
                                                <label
                                                  htmlFor={`choice-${choice.id}`}
                                                  className="checkbox-label"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleChoiceToggle(
                                                      choice,
                                                      setFieldValue,
                                                    );
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  {choice.name}
                                                </label>
                                              </div>
                                            </div>
                                          ),
                                        )
                                      ) : (
                                        <div className="col-12 text-center py-4">
                                          <p>Loading location factors...</p>
                                        </div>
                                      )}
                                    </div>
                                    {touched.locationFactors &&
                                      errors.locationFactors && (
                                        <div className="error-message text-danger mt-2">
                                          {errors.locationFactors}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              )} */}

                              {step === 2 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>In which state do you live?</h5>

                                      <p className="step-subtitle">
                                        Select your current state so we can
                                        compare salaries and living costs
                                        against other locations accurately.
                                      </p>
                                    </div>
                                    <div className="skip-btn d-none d-xl-block ">
                                      <button
                                        type="button"
                                        onClick={handleSkip}
                                        disabled={isSkipping || isLoading}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        {isSkipping ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          </>
                                        ) : (
                                          "Skip"
                                        )}
                                      </button>
                                    </div>
                                  </div>

                                  <div className="current-city">
                                    {/* <h6 className="main-label">
                                      Select Current City.
                                    </h6> */}
                                    <div className="row">
                                      <div className="col-md-6">
                                        <Form.Group className="form-group">
                                          <Form.Label className="col-label">
                                            State
                                          </Form.Label>
                                          <Select
                                            options={stateOptions}
                                            value={
                                              stateOptions.find(
                                                (opt) =>
                                                  opt.value ===
                                                  registerCities.current.state
                                                    ?.value,
                                              ) || null
                                            }
                                            onChange={(selected) => {
                                              setRegisterCities((prev) => ({
                                                ...prev,
                                                current: {
                                                  state: selected,
                                                  city: null,
                                                },
                                              }));
                                              setFieldValue(
                                                "currentState",
                                                selected?.value || "",
                                              );
                                              setFieldValue("currentCity", "");
                                            }}
                                            menuPosition="fixed"
                                            styles={{
                                              menu: (base) => ({
                                                ...base,
                                                borderRadius: "15px",
                                                marginTop: "8px",
                                                backgroundColor: "var(--mmp-surface)",
                                                padding: "6px",
                                                zIndex: "1000",
                                              }),
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                borderRadius: "8px",
                                                padding: "10px",
                                                backgroundColor: state.isFocused
                                                  ? "var(--mmp-hover-bg)"
                                                  : "var(--mmp-surface)",
                                                color: "var(--mmp-text-primary)",
                                                cursor: "pointer",
                                                "&:active": {
                                                  backgroundColor: "var(--mmp-hover-bg)",
                                                },
                                              }),
                                            }}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Search or Select State"
                                            isClearable
                                          />
                                          {errors.currentState &&
                                            touched.currentState && (
                                              <div className="error-message text-danger mt-2">
                                                {errors.currentState}
                                              </div>
                                            )}
                                        </Form.Group>
                                      </div>

                                      <div className="col-md-6">
                                        <Form.Group className="form-group">
                                          <Form.Label className="col-label">
                                            City
                                          </Form.Label>
                                          <Select
                                            options={currentCityOptions}
                                            value={
                                              currentCityOptions.find(
                                                (opt) =>
                                                  opt.value ===
                                                  registerCities.current.city
                                                    ?.value,
                                              ) || null
                                            }
                                            onChange={(selected) => {
                                              setRegisterCities((prev) => ({
                                                ...prev,
                                                current: {
                                                  ...prev.current,
                                                  city: selected,
                                                },
                                              }));
                                              setFieldValue(
                                                "currentCity",
                                                selected?.value || "",
                                              );
                                            }}
                                            menuPosition="fixed"
                                            styles={{
                                              menu: (base) => ({
                                                ...base,
                                                borderRadius: "15px",
                                                marginTop: "8px",
                                                backgroundColor: "var(--mmp-surface)",
                                                padding: "6px",
                                                zIndex: "1000",
                                              }),
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                borderRadius: "8px",
                                                padding: "10px",
                                                backgroundColor: state.isFocused
                                                  ? "var(--mmp-hover-bg)"
                                                  : "var(--mmp-surface)",
                                                color: "var(--mmp-text-primary)",
                                                cursor: "pointer",
                                                "&:active": {
                                                  backgroundColor: "var(--mmp-hover-bg)",
                                                },
                                              }),
                                            }}
                                            placeholder="Search or Select City"
                                            isDisabled={
                                              !registerCities.current.state
                                            }
                                            isClearable
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                          />
                                          {errors.currentCity &&
                                            touched.currentCity && (
                                              <div className="error-message text-danger mt-2">
                                                {errors.currentCity}
                                              </div>
                                            )}
                                        </Form.Group>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {step === 3 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>
                                        Where are you considering relocating?
                                      </h5>

                                      <p className="step-subtitle">
                                        Select your destination state and city
                                        to compare salaries, cost of living, and
                                        job opportunities in your desired
                                        location.
                                      </p>
                                    </div>
                                    <div className="skip-btn d-none d-xl-block ">
                                      <button
                                        type="button"
                                        onClick={handleSkip}
                                        disabled={isSkipping || isLoading}
                                        className="d-flex align-items-center gap-2"
                                      >
                                        {isSkipping ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          </>
                                        ) : (
                                          "Skip"
                                        )}
                                      </button>
                                    </div>
                                  </div>

                                  <div className="current-city">
                                    {/* <h6 className="main-label">
                                      Select Destination City.
                                    </h6> */}
                                    <div className="row">
                                      <div className="col-md-6 mb-3">
                                        <Form.Group className="form-group">
                                          <Form.Label className="col-label">
                                            State
                                          </Form.Label>
                                          <Select
                                            options={stateOptions}
                                            value={
                                              stateOptions.find(
                                                (opt) =>
                                                  opt.value ===
                                                  registerCities.destination
                                                    .state?.value,
                                              ) || null
                                            }
                                            onChange={(selected) => {
                                              setRegisterCities((prev) => ({
                                                ...prev,
                                                destination: {
                                                  state: selected,
                                                  city: null,
                                                },
                                              }));
                                              setFieldValue(
                                                "destinationState",
                                                selected?.value || "",
                                              );
                                              setFieldValue(
                                                "destinationCity",
                                                "",
                                              );
                                            }}
                                            menuPosition="fixed"
                                            styles={{
                                              menu: (base) => ({
                                                ...base,
                                                borderRadius: "15px",
                                                marginTop: "8px",
                                                backgroundColor: "var(--mmp-surface)",
                                                padding: "6px",
                                                zIndex: "1000",
                                              }),
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                borderRadius: "8px",
                                                padding: "10px",
                                                backgroundColor: state.isFocused
                                                  ? "var(--mmp-hover-bg)"
                                                  : "var(--mmp-surface)",
                                                color: "var(--mmp-text-primary)",
                                                cursor: "pointer",
                                                "&:active": {
                                                  backgroundColor: "var(--mmp-hover-bg)",
                                                },
                                              }),
                                            }}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Search or Select State"
                                            isClearable
                                          />
                                          {errors.destinationState &&
                                            touched.destinationState && (
                                              <div className="error-message text-danger mt-2">
                                                {errors.destinationState}
                                              </div>
                                            )}
                                        </Form.Group>
                                      </div>

                                      <div className="col-md-6 mb-3">
                                        <Form.Group className="form-group">
                                          <Form.Label className="col-label">
                                            City
                                          </Form.Label>
                                          <Select
                                            options={destinationCityOptions}
                                            value={
                                              destinationCityOptions.find(
                                                (opt) =>
                                                  opt.value ===
                                                  registerCities.destination
                                                    .city?.value,
                                              ) || null
                                            }
                                            onChange={(selected) => {
                                              setRegisterCities((prev) => ({
                                                ...prev,
                                                destination: {
                                                  ...prev.destination,
                                                  city: selected,
                                                },
                                              }));
                                              setFieldValue(
                                                "destinationCity",
                                                selected?.value || "",
                                              );
                                            }}
                                            menuPosition="fixed"
                                            styles={{
                                              menu: (base) => ({
                                                ...base,
                                                borderRadius: "15px",
                                                marginTop: "8px",
                                                backgroundColor: "var(--mmp-surface)",
                                                padding: "6px",
                                                zIndex: "1000",
                                              }),
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                              option: (base, state) => ({
                                                ...base,
                                                borderRadius: "8px",
                                                padding: "10px",
                                                backgroundColor: state.isFocused
                                                  ? "var(--mmp-hover-bg)"
                                                  : "var(--mmp-surface)",
                                                color: "var(--mmp-text-primary)",
                                                cursor: "pointer",
                                                "&:active": {
                                                  backgroundColor: "var(--mmp-hover-bg)",
                                                },
                                              }),
                                            }}
                                            placeholder=" Search or Select City"
                                            isClearable
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            isDisabled={
                                              !registerCities.destination.state
                                            }
                                          />
                                          {errors.destinationCity &&
                                            touched.destinationCity && (
                                              <div className="error-message text-danger mt-2">
                                                {errors.destinationCity}
                                              </div>
                                            )}
                                        </Form.Group>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="popular-cities ">
                                    <h6 className="main-label">
                                      Popular Locations
                                    </h6>

                                    <div className="popular-list">
                                      {popularCities &&
                                      popularCities.length > 0 ? (
                                        popularCities
                                          .slice(0, 6)
                                          .map((item, index) => (
                                            <div
                                              key={index}
                                              className="popular-tile"
                                              onClick={() =>
                                                handlePopularDestinationSelect(
                                                  item,
                                                  setFieldValue,
                                                )
                                              }
                                            >
                                              <span className="city">
                                                {item.city}
                                              </span>
                                              <span className="separator">
                                                ,
                                              </span>
                                              <span className="state">
                                                {item.state}
                                              </span>
                                            </div>
                                          ))
                                      ) : (
                                        <div className="no-data">
                                          No Popular Locations available
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* {step === 3 && (
                                <Step5CompareCityState
                                  registerDestinations={registerDestinations}
                                  setRegisterDestinations={
                                    setRegisterDestinations
                                  }
                                  showRegistrationSteps={showRegistrationSteps}
                                />
                              )} */}

                              {/* {step === 6 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>Connect your social profiles</h5>
                                      <p className="step-subtitle">
                                        Link your social profiles to save your
                                        results, track comparisons, and get
                                        personalized career insights anytime.
                                      </p>
                                    </div>
                                    
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6 mb-3">
                                      <Form.Group
                                        controlId="facebook"
                                        className="form-group"
                                      >
                                        <Form.Label className="col-label with-icon">
                                          <FormLabelFacebook /> Facebook
                                        </Form.Label>
                                        <Form.Control
                                          type="url"
                                          name="socialProfiles.facebook"
                                          value={values.socialProfiles.facebook}
                                          onChange={(e) => {
                                            handleChange(e);
                                            setRegisterProfiles((prev) => ({
                                              ...prev,
                                              facebook: {
                                                value: e.target.value,
                                              },
                                            }));
                                          }}
                                          onBlur={handleBlur}
                                          placeholder="https://facebook.com/yourprofile"
                                          className="col-input"
                                        />
                                      </Form.Group>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                      <Form.Group
                                        controlId="instagram"
                                        className="form-group"
                                      >
                                        <Form.Label className="col-label with-icon">
                                          <FormLabelIntagram /> Instagram
                                        </Form.Label>
                                        <Form.Control
                                          type="url"
                                          name="socialProfiles.instagram"
                                          value={
                                            values.socialProfiles.instagram
                                          }
                                          onChange={(e) => {
                                            handleChange(e);
                                            setRegisterProfiles((prev) => ({
                                              ...prev,
                                              instagram: {
                                                value: e.target.value,
                                              },
                                            }));
                                          }}
                                          onBlur={handleBlur}
                                          placeholder="https://instagram.com/yourprofile"
                                          className="col-input"
                                        />
                                      </Form.Group>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                      <Form.Group
                                        controlId="linkedin"
                                        className="form-group"
                                      >
                                        <Form.Label className="col-label with-icon">
                                          <FormLabelLinkedIn /> LinkedIn
                                        </Form.Label>
                                        <Form.Control
                                          type="url"
                                          name="socialProfiles.linkedin"
                                          value={values.socialProfiles.linkedin}
                                          onChange={(e) => {
                                            handleChange(e);
                                            setRegisterProfiles((prev) => ({
                                              ...prev,
                                              linkedin: {
                                                value: e.target.value,
                                              },
                                            }));
                                          }}
                                          onBlur={handleBlur}
                                          placeholder="https://linkedin.com/yourprofile"
                                          className="col-input"
                                        />
                                      </Form.Group>
                                    </div>
                                  </div>
                                </div>
                              )} */}

                              {/* {step === 7 && (
                                <div className="step-form">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>Upload your document</h5>
                                      <p className="step-subtitle">
                                        Upload your resume or related document
                                        to receive tailored salary insights and
                                        career guidance.
                                      </p>
                                    </div>
                                  </div>

                                  <div className="upload-section">
                                    <div className="row">
                                      <div className="upload-item col-md-6">
                                        <div className="contentwrap">
                                          <span>Upload Contract</span>
                                          <Button
                                            variant="primary"
                                            onClick={() =>
                                              document
                                                .getElementById(
                                                  "contractUpload",
                                                )
                                                .click()
                                            }
                                          >
                                            Select file
                                          </Button>
                                        </div>
                                        <div className="upload-details">
                                          <input
                                            id="contractUpload"
                                            type="file"
                                            accept=".pdf,.doc,.docx"
                                            style={{ display: "none" }}
                                            onChange={(e) =>
                                              handleFileChange(e, setFieldValue)
                                            }
                                          />
                                          {values.uploadedContract && (
                                            <>
                                              <div className="selected-file">
                                                <span className="file-chip">
                                                  {values.uploadedContract.name}
                                                  <span className="file-size">{` (${(
                                                    values.uploadedContract
                                                      .size / 1024
                                                  ).toFixed(0)} KB)`}</span>
                                                </span>
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  type="button"
                                                  onClick={() => {
                                                    setFile(null);
                                                    setFileUrl(null);
                                                    setFieldValue(
                                                      "uploadedContract",
                                                      null,
                                                    );
                                                  }}
                                                >
                                                  Remove
                                                </Button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>

                                      <div className="upload-item col-md-6">
                                        <div className="contentwrap">
                                          <span>Upload Pay Stubs</span>
                                          <Button
                                            variant="primary"
                                            onClick={() =>
                                              document
                                                .getElementById(
                                                  "payStubsUpload",
                                                )
                                                .click()
                                            }
                                          >
                                            Select file
                                          </Button>
                                        </div>
                                        <div className="upload-details">
                                          <input
                                            id="payStubsUpload"
                                            type="file"
                                            accept=".pdf,.doc,.docx"
                                            style={{ display: "none" }}
                                            onChange={(e) =>
                                              handleSecondFileChange(
                                                e,
                                                setFieldValue,
                                              )
                                            }
                                          />
                                          {values.uploadedPayStubs && (
                                            <>
                                              <div className="selected-file">
                                                <span className="file-chip">
                                                  {values.uploadedPayStubs.name}
                                                  <span className="file-size">{` (${(
                                                    values.uploadedPayStubs
                                                      .size / 1024
                                                  ).toFixed(0)} KB)`}</span>
                                                </span>
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  type="button"
                                                  onClick={() => {
                                                    setSecondFile(null);
                                                    setFieldValue(
                                                      "uploadedPayStubs",
                                                      null,
                                                    );
                                                  }}
                                                >
                                                  Remove
                                                </Button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )} */}

                              {/* {step === 8 && (
                                <div className="step-form subscription-plans">
                                  <div className="step-title-subtitle">
                                    <div className="title-subtitle">
                                      <h5>Subscription membership</h5>

                                      <p className="step-subtitle">
                                        Create your free Map My Pay account to
                                        get started.
                                      </p>
                                      <p className="step-subtitle">
                                        Choose a subscription plan to unlock
                                        full access to salary comparisons,
                                        personalized insights, and advanced
                                        career tools.
                                      </p>
                                      <p className="step-subtitle">
                                        Make data-driven career decisions.
                                      </p>
                                    </div>
                                  </div>

                                  <div className="subscription-card-wrapper mb-3">
                                    <SubscriptionCard />
                                  </div>

                                  <div className="buttons d-flex align-items-center justify-content-center">
                                    <div className="col-6">
                                      <Button
                                        variant="secondary"
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={prevStep}
                                        disabled={isSubmitting}
                                      >
                                        <ChevronLeftIcon className="button-icon" />{" "}
                                        Back
                                      </Button>
                                    </div>

                                    <div className="col-6 d-flex justify-content-end">
                                      <Button
                                        variant="primary"
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={onSubmitRole}
                                        disabled={isLoading}
                                      >
                                        {isLoading ? "Submitting..." : "Finish"}
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              )} */}

                              {errors.submit && (
                                <div className="error-alert">
                                  {errors.submit}
                                </div>
                              )}

                              {step <= 3 && (
                                <div className="buttons d-flex align-items-center justify-content-center">
                                  {step > 1 && (
                                    <div className="col-6">
                                      <button
                                        type="button"
                                        variant="secondary"
                                        onClick={prevStep}
                                        disabled={step === 1}
                                        className="btn btn-secondary"
                                      >
                                        <ChevronLeftIcon className="button-icon" />{" "}
                                        Back
                                      </button>
                                    </div>
                                  )}

                                  <div
                                    className={`col-6 ${
                                      step === 1 ? "col-12" : "col-md-6"
                                    } d-flex justify-content-end`}
                                  >
                                    {/* <button
                                      type="button"
                                      variant="primary"
                                      onClick={nextStep}
                                      className={`btn btn-primary ${
                                        step === 1 ? `mobile` : ""
                                      } ${
                                        step < totalSteps
                                          ? "next-button"
                                          : "submit-button"
                                      }`}
                                      disabled={false}
                                    >
                                      {step === 3 ? "Save" : "Next"}
                                      {step !== 3 && (
                                        <ChevronRightIcon className="button-icon" />
                                      )}
                                    </button> */}
                                    <button
                                      type="button"
                                      onClick={
                                        step === totalSteps
                                          ? handleSubmit
                                          : nextStep
                                      }
                                      className={`btn btn-primary ${
                                        step < totalSteps
                                          ? "next-button"
                                          : "submit-button"
                                      }`}
                                      disabled={
                                        step === totalSteps && isLoading
                                      }
                                    >
                                      {step === totalSteps && isLoading ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          Saving...
                                        </>
                                      ) : (
                                        <>
                                          {step === totalSteps
                                            ? "Save"
                                            : "Next"}
                                          {step !== totalSteps && (
                                            <ChevronRightIcon className="button-icon" />
                                          )}
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    )}
                  </Formik>
                )}
              </Container>
            </div>
          </section>
        )
      ) : (
        <section className="login-content with-register">
          <div className="breadcrumbs pb-0">
            <Container>
              <nav aria-label="Breadcrumb">
                <ul className="breadcrumb-list">
                  <li className="breadcrumb-item">
                    <a href="/">
                      <span>Home</span>
                    </a>
                  </li>
                  <li className="breadcrumb-sep" aria-hidden="true">
                    /
                  </li>
                  <li className="breadcrumb-item current" aria-current="page">
                    <span>Registration Steps</span>
                  </li>
                </ul>
              </nav>
            </Container>
          </div>

          <div className="registration-content">
            <Container>
              {isLoadingData || !isDataLoaded ? (
                <div className="text-center py-5">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading form data...</p>
                  {/* Debug info */}(
                  <div className="mt-3 text-muted small">
                    <p>
                      Roles:{" "}
                      {registerStore?.roleItems?.describe_roles ? "✓" : "✗"}
                    </p>
                    <p>
                      Experience:{" "}
                      {registerStore?.experienceItems?.nursing_experiences
                        ? "✓"
                        : "✗"}
                    </p>
                    <p>
                      Location Choices:{" "}
                      {registerStore?.locationChoiceItems?.location_choices
                        ? "✓"
                        : "✗"}
                    </p>
                    <p>
                      States: {registerStore?.stateItems?.states ? "✓" : "✗"}
                    </p>
                  </div>
                  )
                </div>
              ) : (
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSubmitRole}
                  validate={(values) => {
                    const schema = getValidationSchema(step);
                    try {
                      schema.validateSync(values, { abortEarly: false });
                      return {};
                    } catch (error) {
                      const errors = {};
                      if (error && Array.isArray(error.inner)) {
                        error.inner.forEach((err) => {
                          if (err.path && !errors[err.path]) {
                            errors[err.path] = err.message;
                          }
                        });
                      }
                      return errors;
                    }
                  }}
                  validateOnChange={true}
                  validateOnBlur={true}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit} className="registration-form">
                      <div className="row">
                        <div className="progress-card">
                          <div className="content-wrap">
                            <ul className="steps-list">
                              {steps.map((item) => (
                                <li
                                  key={item.number}
                                  className={`step-item ${
                                    step === item.number ? "active" : ""
                                  } ${step > item.number ? "completed" : ""}`}
                                >
                                  <div className="step-marker">
                                    {step > item.number ? (
                                      <CheckIcon className="check-icon" />
                                    ) : (
                                      <span className="step-number">
                                        {item.number}
                                      </span>
                                    )}
                                  </div>
                                  <div className="step-details">
                                    <div className="step-title">
                                      Step{" "}
                                      {step > item.number ? item.number : ""}
                                    </div>
                                    <div className="step-description">
                                      {item.title}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className="form-content-card">
                          <div className="content-wrap">
                            <div className="steps-count d-flex d-xl-none align-items-center justify-content-between">
                              {`Step ${step} of ${steps.length}`}
                              <div className="skip-btn  d-none d-xl-block">
                                {/* <button type="button" onClick={handleSkip}>
                                  Skip
                                </button> */}
                                <button
                                  type="button"
                                  onClick={handleSkip}
                                  disabled={isSkipping || isLoading}
                                  className="d-flex align-items-center gap-2"
                                >
                                  {isSkipping ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      {/* Skipping... */}
                                    </>
                                  ) : (
                                    "Skip"
                                  )}
                                </button>
                              </div>
                            </div>

                            {step === 1 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>
                                      What best describes your current role?
                                    </h5>
                                    <p className="step-subtitle">
                                      Select your nursing role to view salary
                                      data and career insights tailored to your
                                      profession. This helps ensure accurate
                                      comparisons and guidance.
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block">
                                    {/* <button type="button" onClick={handleSkip}>
                                      Skip
                                    </button> */}
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          {/* Skipping... */}
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="radio-options">
                                  <div className="row">
                                    {registerStore?.roleItems?.describe_roles
                                      ?.length > 0 ? (
                                      registerStore.roleItems.describe_roles.map(
                                        (role) => (
                                          <div
                                            key={role.id}
                                            className={`radio-option col-lg-6 ${
                                              registerRole?.id === role.id
                                                ? "selected"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              setRegisterRole(role);
                                              setFieldValue(
                                                "role",
                                                role.id.toString(),
                                              );
                                            }}
                                          >
                                            <div className="contentwrap">
                                              <input
                                                type="radio"
                                                name="role"
                                                id={`role-${role.id}`}
                                                checked={
                                                  registerRole?.id === role.id
                                                }
                                                onChange={() => {}}
                                              />
                                              <label
                                                htmlFor={`role-${role.id}`}
                                                className="radio-label"
                                              >
                                                {role.name}
                                              </label>
                                            </div>
                                          </div>
                                        ),
                                      )
                                    ) : (
                                      <div className="col-12 text-center py-4">
                                        <p>Loading roles...</p>
                                      </div>
                                    )}
                                  </div>
                                  {errors.role && touched.role && (
                                    <div className="error-message text-danger mt-2">
                                      {errors.role}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            {/* {step === 2 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>
                                      How many years of nursing experience do
                                      you have?
                                    </h5>
                                    <p className="step-subtitle">
                                      Enter your years of experience to get
                                      salary insights that match your career
                                      stage and expertise level.
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block">
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="radio-options">
                                  <div className="row">
                                    {registerStore?.experienceItems
                                      ?.nursing_experiences?.length > 0 ? (
                                      registerStore.experienceItems.nursing_experiences.map(
                                        (exp) => (
                                          <div
                                            key={exp.id}
                                            className={`radio-option col-lg-6 ${
                                              registerExperience?.id === exp.id
                                                ? "selected"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              setRegisterExperience(exp);
                                              setFieldValue(
                                                "experience",
                                                exp.id.toString(),
                                              );
                                            }}
                                          >
                                            <div className="contentwrap">
                                              <input
                                                type="radio"
                                                name="experience"
                                                id={`exp-${exp.id}`}
                                                checked={
                                                  registerExperience?.id ===
                                                  exp.id
                                                }
                                                onChange={() => {}}
                                              />
                                              <label
                                                htmlFor={`exp-${exp.id}`}
                                                className="radio-label"
                                              >
                                                {exp.name}
                                              </label>
                                            </div>
                                          </div>
                                        ),
                                      )
                                    ) : (
                                      <div className="col-12 text-center py-4">
                                        <p>Loading experience levels...</p>
                                      </div>
                                    )}
                                  </div>
                                  {touched.experience && errors.experience && (
                                    <div className="error-message text-danger mt-2">
                                      {errors.experience}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )} */}

                            {/* {step === 3 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>
                                      Which factors are most important in your
                                      location choice?
                                    </h5>
                                    <p className="step-subtitle">
                                      Choose up to two factors that matter most
                                      such as salary, cost of living, job
                                      opportunities, or lifestyle
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block">
                                    
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="checkbox-options">
                                  <div className="row">
                                    {registerStore?.locationChoiceItems
                                      ?.location_choices?.length > 0 ? (
                                      registerStore.locationChoiceItems.location_choices.map(
                                        (choice) => (
                                          <div
                                            key={choice.id}
                                            className={`checkbox-option col-lg-6 ${
                                              registerChoice.includes(choice.id)
                                                ? "selected"
                                                : ""
                                            }`}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleChoiceToggle(
                                                choice,
                                                setFieldValue,
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div className="contentwrap">
                                              <input
                                                type="checkbox"
                                                name={`choice-${choice.id}`}
                                                id={`choice-${choice.id}`}
                                                checked={registerChoice.includes(
                                                  choice.id,
                                                )}
                                                onChange={(e) => {
                                                  e.stopPropagation();
                                                  handleChoiceToggle(
                                                    choice,
                                                    setFieldValue,
                                                  );
                                                }}
                                                style={{ cursor: "pointer" }}
                                              />
                                              <label
                                                htmlFor={`choice-${choice.id}`}
                                                className="checkbox-label"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleChoiceToggle(
                                                    choice,
                                                    setFieldValue,
                                                  );
                                                }}
                                                style={{ cursor: "pointer" }}
                                              >
                                                {choice.name}
                                              </label>
                                            </div>
                                          </div>
                                        ),
                                      )
                                    ) : (
                                      <div className="col-12 text-center py-4">
                                        <p>Loading location factors...</p>
                                      </div>
                                    )}
                                  </div>
                                  {touched.locationFactors &&
                                    errors.locationFactors && (
                                      <div className="error-message text-danger mt-2">
                                        {errors.locationFactors}
                                      </div>
                                    )}
                                </div>
                              </div>
                            )} */}

                            {step === 2 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>In which state do you live?</h5>
                                    <p className="step-subtitle">
                                      Select your current state so we can
                                      compare salaries and living costs against
                                      other locations accurately.
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block ">
                                    {/* <button type="button" onClick={handleSkip}>
                                      Skip
                                    </button> */}
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          {/* Skipping... */}
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="current-city">
                                  {/* <h6 className="main-label">
                                    Select Current City.
                                  </h6> */}
                                  <div className="row">
                                    <div className="col-md-6">
                                      <Form.Group className="form-group">
                                        <Form.Label className="col-label">
                                          State
                                        </Form.Label>
                                        <Select
                                          options={stateOptions}
                                          value={
                                            stateOptions.find(
                                              (opt) =>
                                                opt.value ===
                                                registerCities.current.state
                                                  ?.value,
                                            ) || null
                                          }
                                          onChange={(selected) => {
                                            setRegisterCities((prev) => ({
                                              ...prev,
                                              current: {
                                                state: selected,
                                                city: null,
                                              },
                                            }));
                                            setFieldValue(
                                              "currentState",
                                              selected?.value || "",
                                            );
                                            setFieldValue("currentCity", "");
                                          }}
                                          menuPosition="fixed"
                                          styles={{
                                            menu: (base) => ({
                                              ...base,
                                              borderRadius: "15px",
                                              marginTop: "8px",
                                              backgroundColor: "var(--mmp-surface)",
                                              padding: "6px",
                                              zIndex: "1000",
                                            }),
                                            menuPortal: (base) => ({
                                              ...base,
                                              zIndex: 9999,
                                            }),
                                            option: (base, state) => ({
                                              ...base,
                                              borderRadius: "8px",
                                              padding: "10px",
                                              backgroundColor: state.isFocused
                                                ? "var(--mmp-hover-bg)"
                                                : "var(--mmp-surface)",
                                              color: "var(--mmp-text-primary)",
                                              cursor: "pointer",
                                              "&:active": {
                                                backgroundColor: "var(--mmp-hover-bg)",
                                              },
                                            }),
                                          }}
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                          placeholder="Search or Select State"
                                          isClearable
                                        />
                                        {errors.currentState &&
                                          touched.currentState && (
                                            <div className="error-message text-danger mt-2">
                                              {errors.currentState}
                                            </div>
                                          )}
                                      </Form.Group>
                                    </div>

                                    <div className="col-md-6">
                                      <Form.Group className="form-group">
                                        <Form.Label className="col-label">
                                          City
                                        </Form.Label>

                                        <CreatableSelect
                                          options={currentCityOptions}
                                          value={
                                            currentCityOptions.find(
                                              (opt) =>
                                                opt.value ===
                                                registerCities.current.city
                                                  ?.value,
                                            ) ||
                                            registerCities.current.city ||
                                            null
                                          }
                                          onChange={(selected) => {
                                            setRegisterCities((prev) => ({
                                              ...prev,
                                              current: {
                                                ...prev.current,
                                                city: selected,
                                              },
                                            }));

                                            setFieldValue(
                                              "currentCity",
                                              selected?.value || "",
                                            );
                                          }}
                                          onCreateOption={(inputValue) => {
                                            const formattedValue = inputValue.trim();
                                            if (!formattedValue) return;

                                            // Duplicate check (case-insensitive)
                                            const isDuplicate = currentCityOptions.some(
                                              (option) =>
                                                option.value.toLowerCase() ===
                                                formattedValue.toLowerCase(),
                                            );

                                            if (isDuplicate) {
                                              alert("City already exists!");
                                              return;
                                            }

                                            const newOption = {
                                              label: formattedValue,
                                              value: formattedValue,
                                            };

                                            // Add to options
                                            setCurrentCityOptions((prev) => [
                                              ...prev,
                                              newOption,
                                            ]);

                                            // Update local state
                                            setRegisterCities((prev) => ({
                                              ...prev,
                                              current: {
                                                ...prev.current,
                                                city: newOption,
                                              },
                                            }));

                                            // Update Formik
                                            setFieldValue(
                                              "currentCity",
                                              formattedValue,
                                            );
                                          }}
                                          formatCreateLabel={(inputValue) =>
                                            `City "${inputValue}"`
                                          }
                                          menuPosition="fixed"
                                          styles={{
                                            menu: (base) => ({
                                              ...base,
                                              borderRadius: "15px",
                                              marginTop: "8px",
                                              backgroundColor: "var(--mmp-surface)",
                                              padding: "6px",
                                              zIndex: "1000",
                                            }),
                                            menuPortal: (base) => ({
                                              ...base,
                                              zIndex: 9999,
                                            }),
                                            option: (base, state) => ({
                                              ...base,
                                              borderRadius: "8px",
                                              padding: "10px",
                                              backgroundColor: state.isFocused
                                                ? "var(--mmp-hover-bg)"
                                                : "var(--mmp-surface)",
                                              color: "var(--mmp-text-primary)",
                                              cursor: "pointer",
                                              "&:active": {
                                                backgroundColor: "var(--mmp-hover-bg)",
                                              },
                                            }),
                                          }}
                                          placeholder="Search or Select City"
                                          isDisabled={
                                            !registerCities.current.state
                                          }
                                          isClearable
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                        />

                                        {errors.currentCity &&
                                          touched.currentCity && (
                                            <div className="error-message text-danger mt-2">
                                              {errors.currentCity}
                                            </div>
                                          )}
                                      </Form.Group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {step === 3 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>
                                      Where are you considering relocating?
                                    </h5>
                                    <p className="step-subtitle">
                                      Select your destination state and city to
                                      compare salaries, cost of living, and job
                                      opportunities in your desired location.
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block ">
                                    {/* <button type="button" onClick={handleSkip}>
                                      Skip
                                    </button> */}
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          {/* Skipping... */}
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="current-city">
                                  {/* <h6 className="main-label">
                                    Select Destination City.
                                  </h6> */}
                                  <div className="row">
                                    <div className="col-md-6 mb-3">
                                      <Form.Group className="form-group">
                                        <Form.Label className="col-label">
                                          State
                                        </Form.Label>
                                        <Select
                                          options={stateOptions}
                                          value={
                                            stateOptions.find(
                                              (opt) =>
                                                opt.value ===
                                                registerCities.destination.state
                                                  ?.value,
                                            ) || null
                                          }
                                          onChange={(selected) => {
                                            setRegisterCities((prev) => ({
                                              ...prev,
                                              destination: {
                                                state: selected,
                                                city: null,
                                              },
                                            }));
                                            setFieldValue(
                                              "destinationState",
                                              selected?.value || "",
                                            );
                                            setFieldValue(
                                              "destinationCity",
                                              "",
                                            );
                                          }}
                                          menuPosition="fixed"
                                          styles={{
                                            menu: (base) => ({
                                              ...base,
                                              borderRadius: "15px",
                                              marginTop: "8px",
                                              backgroundColor: "var(--mmp-surface)",
                                              padding: "6px",
                                              zIndex: "1000",
                                            }),
                                            menuPortal: (base) => ({
                                              ...base,
                                              zIndex: 9999,
                                            }),
                                            option: (base, state) => ({
                                              ...base,
                                              borderRadius: "8px",
                                              padding: "10px",
                                              backgroundColor: state.isFocused
                                                ? "var(--mmp-hover-bg)"
                                                : "var(--mmp-surface)",
                                              color: "var(--mmp-text-primary)",
                                              cursor: "pointer",
                                              "&:active": {
                                                backgroundColor: "var(--mmp-hover-bg)",
                                              },
                                            }),
                                          }}
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                          placeholder="Search or Select State"
                                          isClearable
                                        />
                                        {errors.destinationState &&
                                          touched.destinationState && (
                                            <div className="error-message text-danger mt-2">
                                              {errors.destinationState}
                                            </div>
                                          )}
                                      </Form.Group>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                      <Form.Group className="form-group">
                                        <Form.Label className="col-label">
                                          City
                                        </Form.Label>

                                        <CreatableSelect
                                          options={destinationCityOptions}
                                          value={
                                            destinationCityOptions.find(
                                              (opt) =>
                                                opt.value ===
                                                registerCities.destination.city
                                                  ?.value,
                                            ) ||
                                            registerCities.destination.city ||
                                            null
                                          }
                                          onChange={(selected) => {
                                            setRegisterCities((prev) => ({
                                              ...prev,
                                              destination: {
                                                ...prev.destination,
                                                city: selected,
                                              },
                                            }));

                                            setFieldValue(
                                              "destinationCity",
                                              selected?.value || "",
                                            );
                                          }}
                                          onCreateOption={(inputValue) => {
                                            const formattedValue = inputValue.trim();
                                            if (!formattedValue) return;

                                            // Prevent duplicate (case-insensitive)
                                            const isDuplicate = destinationCityOptions.some(
                                              (option) =>
                                                option.value.toLowerCase() ===
                                                formattedValue.toLowerCase(),
                                            );

                                            if (isDuplicate) {
                                              alert("City already exists!");
                                              return;
                                            }

                                            const newOption = {
                                              label: formattedValue,
                                              value: formattedValue,
                                            };

                                            // Add to dropdown options
                                            setDestinationCityOptions(
                                              (prev) => [...prev, newOption],
                                            );

                                            // Update local state
                                            setRegisterCities((prev) => ({
                                              ...prev,
                                              destination: {
                                                ...prev.destination,
                                                city: newOption,
                                              },
                                            }));

                                            // Update Formik
                                            setFieldValue(
                                              "destinationCity",
                                              formattedValue,
                                            );
                                          }}
                                          formatCreateLabel={(inputValue) =>
                                            `City "${inputValue}"`
                                          }
                                          menuPosition="fixed"
                                          styles={{
                                            menu: (base) => ({
                                              ...base,
                                              borderRadius: "15px",
                                              marginTop: "8px",
                                              backgroundColor: "var(--mmp-surface)",
                                              padding: "6px",
                                              zIndex: "1000",
                                            }),
                                            menuPortal: (base) => ({
                                              ...base,
                                              zIndex: 9999,
                                            }),
                                            option: (base, state) => ({
                                              ...base,
                                              borderRadius: "8px",
                                              padding: "10px",
                                              backgroundColor: state.isFocused
                                                ? "var(--mmp-hover-bg)"
                                                : "var(--mmp-surface)",
                                              color: "var(--mmp-text-primary)",
                                              cursor: "pointer",
                                              "&:active": {
                                                backgroundColor: "var(--mmp-hover-bg)",
                                              },
                                            }),
                                          }}
                                          placeholder="Search or Select City"
                                          isClearable
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                          isDisabled={
                                            !registerCities.destination.state
                                          }
                                        />

                                        {errors.destinationCity &&
                                          touched.destinationCity && (
                                            <div className="error-message text-danger mt-2">
                                              {errors.destinationCity}
                                            </div>
                                          )}
                                      </Form.Group>
                                    </div>
                                  </div>
                                </div>
                                <div className="popular-cities ">
                                  <h6 className="main-label">
                                    Popular Locations
                                  </h6>

                                  <div className="popular-list">
                                    {popularCities &&
                                    popularCities.length > 0 ? (
                                      popularCities
                                        .slice(0, 6)
                                        .map((item, index) => (
                                          <div
                                            key={index}
                                            className="popular-tile"
                                            onClick={() =>
                                              handlePopularDestinationSelect(
                                                item,
                                                setFieldValue,
                                              )
                                            }
                                          >
                                            <span className="city">
                                              {item.city}
                                            </span>
                                            <span className="separator">,</span>
                                            <span className="state">
                                              {item.state}
                                            </span>
                                          </div>
                                        ))
                                    ) : (
                                      <div className="no-data">
                                        No Popular Locations available
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* {step === 3 && (
                              <Step5CompareCityState
                                registerDestinations={registerDestinations}
                                setRegisterDestinations={
                                  setRegisterDestinations
                                }
                              />
                            )} */}

                            {/* {step === 6 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>Connect your social profiles</h5>
                                    <p className="step-subtitle">
                                      Link your social profiles to save your
                                      results, track comparisons, and get
                                      personalized career insights anytime.
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block">
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-6 mb-3">
                                    <Form.Group
                                      controlId="facebook"
                                      className="form-group"
                                    >
                                      <Form.Label className="col-label with-icon">
                                        <FormLabelFacebook /> Facebook
                                      </Form.Label>
                                      <Form.Control
                                        type="url"
                                        name="socialProfiles.facebook"
                                        value={values.socialProfiles.facebook}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setRegisterProfiles((prev) => ({
                                            ...prev,
                                            facebook: {
                                              value: e.target.value,
                                            },
                                          }));
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="https://facebook.com/yourprofile"
                                        className="col-input"
                                      />
                                    </Form.Group>
                                  </div>

                                  <div className="col-md-6 mb-3">
                                    <Form.Group
                                      controlId="instagram"
                                      className="form-group"
                                    >
                                      <Form.Label className="col-label with-icon">
                                        <FormLabelIntagram /> Instagram
                                      </Form.Label>
                                      <Form.Control
                                        type="url"
                                        name="socialProfiles.instagram"
                                        value={values.socialProfiles.instagram}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setRegisterProfiles((prev) => ({
                                            ...prev,
                                            instagram: {
                                              value: e.target.value,
                                            },
                                          }));
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="https://instagram.com/yourprofile"
                                        className="col-input"
                                      />
                                    </Form.Group>
                                  </div>

                                  <div className="col-md-6 mb-3">
                                    <Form.Group
                                      controlId="linkedin"
                                      className="form-group"
                                    >
                                      <Form.Label className="col-label with-icon">
                                        <FormLabelLinkedIn /> LinkedIn
                                      </Form.Label>
                                      <Form.Control
                                        type="url"
                                        name="socialProfiles.linkedin"
                                        value={values.socialProfiles.linkedin}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setRegisterProfiles((prev) => ({
                                            ...prev,
                                            linkedin: {
                                              value: e.target.value,
                                            },
                                          }));
                                        }}
                                        onBlur={handleBlur}
                                        placeholder="https://linkedin.com/yourprofile"
                                        className="col-input"
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              </div>
                            )} */}

                            {/* {step === 7 && (
                              <div className="step-form">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>Upload your document</h5>
                                    <p className="step-subtitle">
                                      Upload your resume or related document to
                                      receive tailored salary insights and
                                      career guidance.
                                    </p>
                                  </div>
                                  <div className="skip-btn d-none d-xl-block">
                                    <button
                                      type="button"
                                      onClick={handleSkip}
                                      disabled={isSkipping || isLoading}
                                      className="d-flex align-items-center gap-2"
                                    >
                                      {isSkipping ? (
                                        <>
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        </>
                                      ) : (
                                        "Skip"
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="upload-section">
                                  <div className="row">
                                    <div className="upload-item col-md-6">
                                      <div className="contentwrap">
                                        <span>Upload Contract</span>
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            document
                                              .getElementById("contractUpload")
                                              .click()
                                          }
                                        >
                                          Select file
                                        </Button>
                                      </div>
                                      <div className="upload-details">
                                        <input
                                          id="contractUpload"
                                          type="file"
                                          accept=".pdf,.doc,.docx"
                                          style={{ display: "none" }}
                                          onChange={(e) =>
                                            handleFileChange(e, setFieldValue)
                                          }
                                        />
                                        {values.uploadedContract && (
                                          <div className="selected-file">
                                            <span className="file-chip">
                                              {values.uploadedContract.name}
                                              <span className="file-size">{` (${(
                                                values.uploadedContract.size /
                                                1024
                                              ).toFixed(0)} KB)`}</span>
                                            </span>
                                            <Button
                                              variant="outline-danger"
                                              size="sm"
                                              type="button"
                                              onClick={() => {
                                                setFile(null);
                                                setFieldValue(
                                                  "uploadedContract",
                                                  null,
                                                );
                                              }}
                                            >
                                              Remove
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="upload-item col-md-6">
                                      <div className="contentwrap">
                                        <span>Upload Pay Stubs</span>
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            document
                                              .getElementById("payStubsUpload")
                                              .click()
                                          }
                                        >
                                          Select file
                                        </Button>
                                      </div>
                                      <div className="upload-details">
                                        <input
                                          id="payStubsUpload"
                                          type="file"
                                          accept=".pdf,.doc,.docx"
                                          style={{ display: "none" }}
                                          onChange={(e) =>
                                            handleSecondFileChange(
                                              e,
                                              setFieldValue,
                                            )
                                          }
                                        />
                                        {values.uploadedPayStubs && (
                                          <div className="selected-file">
                                            <span className="file-chip">
                                              {values.uploadedPayStubs.name}
                                              <span className="file-size">{` (${(
                                                values.uploadedPayStubs.size /
                                                1024
                                              ).toFixed(0)} KB)`}</span>
                                            </span>
                                            <Button
                                              variant="outline-danger"
                                              size="sm"
                                              type="button"
                                              onClick={() => {
                                                setSecondFile(null);
                                                setFieldValue(
                                                  "uploadedPayStubs",
                                                  null,
                                                );
                                              }}
                                            >
                                              Remove
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )} */}

                            {/* {step === 8 && (
                              <div className="step-form subscription-plans">
                                <div className="step-title-subtitle">
                                  <div className="title-subtitle">
                                    <h5>Subscription membership</h5>
                                    <p className="step-subtitle">
                                      Choose a subscription plan to unlock full
                                      access to salary comparisons, personalized
                                      insights, and advanced career tools.
                                    </p>
                                  </div>
                                </div>

                                <div className="subscription-card-wrapper mb-3">
                                  <SubscriptionCard />
                                </div>

                                <div className="buttons d-flex align-items-center justify-content-center">
                                  <div className="col-6">
                                    <Button
                                      variant="secondary"
                                      type="button"
                                      className="btn btn-secondary"
                                      onClick={prevStep}
                                      disabled={isSubmitting}
                                    >
                                      <ChevronLeftIcon className="button-icon" />{" "}
                                      Back
                                    </Button>
                                  </div>

                                  <div className="col-6 d-flex justify-content-end">
                                    <Button
                                      variant="primary"
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={onSubmitRole}
                                      disabled={isLoading}
                                    >
                                      {isLoading ? "Submitting..." : "Finish"}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            )} */}

                            {errors.submit && (
                              <div className="error-alert">{errors.submit}</div>
                            )}

                            {step <= 3 && (
                              <div className="buttons d-flex align-items-center justify-content-center">
                                {step > 1 && (
                                  <div className="col-6">
                                    <button
                                      type="button"
                                      variant="secondary"
                                      onClick={prevStep}
                                      disabled={step === 1}
                                      className="btn btn-secondary"
                                    >
                                      <ChevronLeftIcon className="button-icon" />{" "}
                                      Back
                                    </button>
                                  </div>
                                )}

                                <div
                                  className={`col-6 ${
                                    step === 1 ? "col-12" : "col-md-6"
                                  } d-flex justify-content-end`}
                                >
                                  {/* <button
                                    type="button"
                                    variant="primary"
                                    onClick={nextStep}
                                    className={`btn btn-primary ${
                                      step === 1 ? `mobile` : ""
                                    } ${
                                      step < totalSteps
                                        ? "next-button"
                                        : "submit-button"
                                    }`}
                                    disabled={false}
                                  >
                                    {step === 7 ? "Save" : "Next"}
                                    {step !== 7 && (
                                      <ChevronRightIcon className="button-icon" />
                                    )}
                                  </button> */}
                                  <button
                                    type="button"
                                    onClick={
                                      step === totalSteps
                                        ? handleSubmit
                                        : nextStep
                                    }
                                    className={`btn btn-primary ${
                                      step < totalSteps
                                        ? "next-button"
                                        : "submit-button"
                                    }`}
                                    disabled={step === totalSteps && isLoading}
                                  >
                                    {step === totalSteps && isLoading ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Saving...
                                      </>
                                    ) : (
                                      <>
                                        {step === totalSteps ? "Save" : "Next"}
                                        {step !== totalSteps && (
                                          <ChevronRightIcon className="button-icon" />
                                        )}
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              )}
            </Container>
          </div>
        </section>
      )}
    </>
  );
}
